import type { ReactElement } from 'react';
import { NavLink } from 'react-router';

/**
 * Meetings, or the series they repeat in.
 *
 * ⚠ This exists because a quiet link in a filter row was not findable.
 * Vladimir, 2026-09-21, having already asked once where series live: *"where
 * to see list of all series and to click to deep dive in them? I can't find
 * this list page anywhere now"*. A thing somebody has to hunt for twice is not
 * hidden by accident — it is in the wrong place — and a series is a meeting
 * that repeats, so it belongs beside the meetings and at the same weight.
 *
 * Not a nav entry: the nav is four words and each one is a different part of
 * the product. These are one part, seen three ways — and channels joined them
 * on 2026-09-24: *"Let's make channels as a tab next to series and remove from
 * header"* (Vladimir). A channel is where meetings are posted; it is a way of
 * looking at meetings, not a place of its own.
 */
export function ListSwitch({
  on,
}: {
  on: 'meetings' | 'calendar' | 'series' | 'channels';
}): ReactElement {
  return (
    <div className="subtabs" role="tablist" aria-label="Meetings, series or collections">
      <NavLink
        to="/meetings"
        role="tab"
        aria-selected={on === 'meetings'}
        className={`tab ${on === 'meetings' ? 'on' : ''}`}
      >
        Meetings
      </NavLink>
      <NavLink
        to="/calendar"
        role="tab"
        aria-selected={on === 'calendar'}
        className={`tab ${on === 'calendar' ? 'on' : ''}`}
      >
        Calendar
      </NavLink>
      <NavLink
        to="/series"
        role="tab"
        aria-selected={on === 'series'}
        className={`tab ${on === 'series' ? 'on' : ''}`}
      >
        Series
      </NavLink>
      <NavLink
        to="/channels"
        role="tab"
        aria-selected={on === 'channels'}
        className={`tab ${on === 'channels' ? 'on' : ''}`}
      >
        Collections
      </NavLink>
    </div>
  );
}
